import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PageTemplateTable } from '../../../../directives/page-template-table/page-template-table';
import { StoreRequestAccessories, StoreRequestGalleries, StoreRequestHeadImage, StoreRequestInternalGalleries, StoreRequestProductServices, StoreRequestPromotionEvent, StoreRequestSearch, StoreRequestUpdateMassiveWhatsapp } from '../../../../models/api-store/store/store.request.model';
import { StoreService } from '../../../../services/api-store/store/store.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { ProductServiceService } from '../../../../services/api-store/product-service/product-service.service';
import { ProductServiceRequestSearch } from '../../../../models/api-store/product-service/product-service.request.model';
import { MassModifyItem } from '../../../../components/ui/mass-modify/mass-modify-item';
import { ChoicePromotioneventModalComponent } from '../../../../components/ui/choice-promotionevent-modal/choice-promotionevent-modal.component';
import { ChoiceProductserviceModalComponent } from '../../../../components/ui/choice-productservice-modal/choice-productservice-modal.component';
import { ChoiceStoreaccessoryModalComponent } from '../../../../components/ui/choice-storeaccessory-modal/choice-storeaccessory-modal.component';
import { ChoiceInternalgalleriesModalComponent } from '../../../../components/ui/choice-internalgalleries-modal/choice-internalgalleries-modal.component';
import { ChoiceGalleriesModalComponent } from '../../../../components/ui/choice-galleries-modal/choice-galleries-modal.component';
import { ChoiceSupervisoriModalComponent } from '../../../../components/ui/choice-supervisori-modal/choice-supervisori-modal.component';
import { LoadImageFromDamComponent } from '../../../../components/ui/load-image-from-dam/load-image-from-dam.component';
import { SupervisorGroupsRequestStores } from '../../../../models/api-store/supervisor-groups/supervisor-groups.request.model';
import { SupervisorGroupsService } from '../../../../services/api-store/supervisor-groups/supervisor-groups.service';
import { environment } from '../../../../../environments/environment';
import { UpdateWhatsappModalComponent } from '../../../ui/update-whatsapp-modal/update-whatsapp-modal.component';
import { ActionConfirmComponent } from '../../../ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.scss']
})
export class StoreComponent extends PageTemplateTable implements OnInit, OnDestroy, AfterViewInit {

  searchFilterForm: FormGroup;
  searchFilterOther = {
    searchFilterField_dealerCategory: [],
    searchFilterField_productServiceIds: []
  }
  public dealerCategorySettings: any = {}
  public dealerCategoryList: any[];
  public menuSettings: any;
  public menuList: any;
  public selectedMenu: any;
  public isEmpty: boolean = false;
  public isSearching: boolean = false;
  public fe_url: string = environment.frontendEnv.url;


  constructor(
    private router: Router,
    private storeService: StoreService,
    private productServiceService: ProductServiceService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private supervisorGroupsService: SupervisorGroupsService
  ) {
    super(modalService);
    this.searchFilterForm = this.fb.group({
      searchOldValue: '',
      searchFilterField: ''
    });
  }

  _dealerCategorySettings() {
    return {
      singleSelection: true,
      text: 'Categoria dealer',
      enableCheckAll: false,
      enableFilterSelectAll: false,
      enableSearchFilter: false,
      searchBy: ['value'],
      classes: 'form-control topic-select',
      showCheckbox: false,
      noDataLabel: 'Nessuna risultato con la ricerca associata',
      searchAutofocus: false,
      lazyLoading: false,
      labelKey: 'value',
      primaryKey: 'value',
      maxHeight: 400
    };
  };

  loadDealerCategoryList() {
    this.storeService.findAllDealerCategories().subscribe(
      (response) => {
        this.dealerCategoryList = [];
        this.setDealerCategoryList(response.dealerCategories);
      });
  }

  setDealerCategoryList(dealerCategories: any) {
    if (typeof dealerCategories != typeof undefined) {
      for (let obj of dealerCategories) {
        this.dealerCategoryList.push({
          value: obj
        });
      }
    }
  }

  /**
   * Inizializza la tabella
   */
  initTable() {
    const that = this;
    this.initCommon_dtOptions();
    this.dtOptions['columnDefs'] = [
      { orderable: false, targets: 0, width: '5%' },
      { orderable: false, targets: 1, width: '15%' },
      { orderable: false, targets: 2, width: '20%' },
      { orderable: false, targets: 3, width: '15%' },
      { orderable: false, targets: 4, width: '15%' },
      { orderable: false, targets: 5, width: '10%' },
      { orderable: false, targets: 6, width: '10%' },
      { orderable: false, targets: 7, width: '5%' },
      { orderable: false, targets: 8, width: '5%' }
    ];
    this.dtOptions['ajax'] = (dataTablesParameters: any, callback) => {
      this.isSearching = true;

      if (dataTablesParameters.start > 0) {
        dataTablesParameters.start = dataTablesParameters.start / this.dimPagina;
      }
      that.numeroPagina = dataTablesParameters.start;
      this.dtOptions.pageLength = this.dimPagina;
      let requestSearch = that.getFilter();
      that.storeService.search(requestSearch).subscribe(
        (response) => {
          if (response != null) {
            if (response.data.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
            that.setListEntityList(response);
            callback({
              recordsTotal: response.total,
              recordsFiltered: response.total,
              data: []
            });
          } else {
            this.isEmpty = true;
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
          that.spinner.hide();
          that.isSearching = false;
        },
        (error: HttpErrorResponse) => {
          console.log(error);
          that.spinner.hide();
          that.isSearching = false;
        }
      );
    }
    this.menuList = this.lengthMenu;
    this.menuSettings = this.settings;
    this.selectedMenu = this.defaultLength;
    this.selectedMenu = [];
    this.selectedMenu.push(this.defaultLength[0]);
  }

  ngOnInit() {
    this.dealerCategorySettings = this._dealerCategorySettings();
    this.loadDealerCategoryList();
    this.initTable();
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  /**
   * Click sulla lente per la ricerca
   */
  clickSearch() {
    this.searchFilterForm.controls.searchOldValue.setValue(this.searchFilterForm.controls.searchFilterField.value);
    this.resetFilter();
    this.ajaxReload();
  }

  changeFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue(this.searchFilterForm.controls.searchOldValue.value);
    this.resetFilter();
    this.trigger();
  }

  changeLengthPage(length) {
    let firstPage = 0;
    this.changeLength(length.value, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.trigger();
  }

  removeLength() {
    let firstPage = 0;
    let length = 10;
    this.selectedMenu.push({ 'value': 10 });
    this.changeLength(length, firstPage);
    this.dtOptions.pageLength = this.dimPagina;
    this.resetFilter();
    this.trigger();
  }


  /**
   * Prende i filtri
   * @returns 
   */
  getFilter() {
    let storeRequestSearch = new StoreRequestSearch();
    storeRequestSearch.q = this.searchFilterForm.controls['searchFilterField'].value;
    storeRequestSearch.pageNumber = this.numeroPagina;
    storeRequestSearch.pageSize = this.dimPagina;

    if (this.searchFilterOther.searchFilterField_dealerCategory.length > 0) {
      storeRequestSearch.dealerCategory = this.searchFilterOther.searchFilterField_dealerCategory[0].value;
    }
    if (this.searchFilterOther.searchFilterField_productServiceIds.length > 0) {
      storeRequestSearch.productServiceIds = this.searchFilterOther.searchFilterField_productServiceIds;
    }

    return storeRequestSearch;
  }

  clickButtonUpdate(id) {
    const url = 'store/store/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
  }


  clickButtonClearFilter() {
    this.searchFilterForm.controls.searchFilterField.setValue('');
    this.searchFilterOther.searchFilterField_dealerCategory = [];
    this.clickSearch();
  }

  onExportXML() {
    this.storeService.exportCSV().subscribe(
      (response) => {
        this.toastr.success('Export CSV inviato', 'Export CSV', {
          timeOut: 5000
        });
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Errore durante la richiesta di invio Export CSV', 'Export CSV', {
          timeOut: 5000
        });
      }
    );
  }


  //Autocomplete - productAndServices  <- Prodotti e Servizi
  @ViewChild('productAndServices ') productAndServices;
  productAndServices_Keyword = 'serviceName';
  productAndServices_Suggestion: any = [];
  productAndServices_Selected: any = [];
  productAndServices_errorMsg: string;
  productAndServices_isKeywordLoadingResult: boolean;

  getFilter_productAndServices(event: any) {
    let request = new ProductServiceRequestSearch();
    request.serviceName = event;
    request.published = true;
    request.pageNumber = 0
    request.pageSize = 20
    return request
  }

  fillSuggestion_productAndServices(response: any) {
    //aggiungo elementi nella suggestion
    for (let obj of response.data) {
      let trovato = false;
      for (let j = 0; j < this.productAndServices_Selected.length && !trovato; j++) {
        if (obj.id == this.productAndServices_Selected[j].id) {
          trovato = true;
        }
      }
      if (!trovato) {
        this.productAndServices_Suggestion.push(obj);
      }
    }
  }
  getList_productAndServices(event) {
    this.productAndServices_isKeywordLoadingResult = true;
    let request = this.getFilter_productAndServices(event);
    this.productServiceService.search(request).subscribe(response => {
      this.productAndServices_Suggestion = [];
      if (response != null && typeof response != typeof undefined) {
        this.fillSuggestion_productAndServices(response);
      }
      this.productAndServices_isKeywordLoadingResult = false;
    });
  }
  searchCleared__productAndServices() {
    this.productAndServices_Suggestion = [];
  }
  selectEvent__productAndServices(item) {
    this.productAndServices_Selected.push(item);
    this.searchFilterOther.searchFilterField_productServiceIds.push(item.id);
    this.productAndServices.clear();
    this.changeFilter();
  }
  onFocused__productAndServices(e) {
    this.getList_productAndServices("");
  }
  //Chip list - productAndServices <- Prodotti e Servizi
  labelKeys_productAndServices = ["serviceName"];
  onChangeItemList_productAndServices(evt: any) {
    this.searchFilterOther.searchFilterField_productServiceIds = [];
    for (let e of evt) {
      this.searchFilterOther.searchFilterField_productServiceIds.push(e.id);
    }
    this.changeFilter();
  }





  /* FUNZIONI PER MODIFICHE DI MASSA */
  titleFlag: string = "Flags"
  public massModifyItemsFlags: MassModifyItem[] = [
    {
      id: 'visibilityEmail',
      title: 'Visibilità Email', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityEmail_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityEmail_FALSE', }
      ]
    },
    {
      id: 'visibilityTelephone',
      title: 'Visibilità Telefono', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityTelephone_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityTelephone_FALSE', }
      ]
    },
    {
      id: 'visibilityClickAndCollectSim',
      title: 'Visibilità C&C SIM', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityClickAndCollectSim_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityClickAndCollectSim_FALSE', }
      ]
    },
    {
      id: 'visibilityClickAndCollectSmartphone',
      title: 'Visibilità C&C SMARTPHONE', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityClickAndCollectSmartphone_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityClickAndCollectSmartphone_FALSE', }
      ]
    },
    {
      id: 'visibilityScheduleAppointments',
      title: 'Visibilità Fissa appuntamento', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityScheduleAppointments_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityScheduleAppointments_FALSE', }
      ]
    },
    {
      id: 'visibilityVideocallme',
      title: 'Visibilità Videochiamaci', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityVideocallme_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityVideocallme_FALSE', }
      ]
    },
    {
      id: 'visibilityGallery',
      title: 'Visibilità Galleria', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityGallery_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityGallery_FALSE', }
      ]
    },
    {
      id: 'visibilityGooglePlace',
      title: 'Visibilità Google place', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityGooglePlace_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityGooglePlace_FALSE', }
      ]
    },
    {
      id: 'visibilityFacebook',
      title: 'Visibilità Facebook', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityFacebook_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityFacebook_FALSE', }
      ]
    },
    {
      id: 'visibilityPromotion',
      title: 'Visibilità sezione Promozioni', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityPromotion_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityPromotion_FALSE', }
      ]
    },
    {
      id: 'visibilityEvent',
      title: 'Visibilità sezione Eventi', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityEvent_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityEvent_FALSE', }
      ]
    },
    {
      id: 'visibilityServices',
      title: 'Visibilità sezione Prodotti', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityServices_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityServices_FALSE', }
      ]
    },
    {
      id: 'visibilityFullStoreDescription',
      title: 'Visibilità sezione Descrizione', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityFullStoreDescription_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityFullStoreDescription_FALSE', }
      ]
    },
    {
      id: 'visibilityInternalGallery',
      title: 'Visibilità Galleria interna', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityInternalGallery_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityInternalGallery_FALSE', }
      ]
    },
    {
      id: 'visibilityOpeningClosingTime',
      title: 'Visibilità sezione Orari', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityOpeningClosingTime_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityOpeningClosingTime_FALSE', }
      ]
    },
    {
      id: 'visibilityManageOpeningClosingTime',
      title: 'Gestione orari custom', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Attiva', icon: '', styleClass: '', value: 'visibilityManageOpeningClosingTime_TRUE', },
        { title: 'Disattiva', icon: '', styleClass: '', value: 'visibilityManageOpeningClosingTime_FALSE', }
      ]
    },
    {
      id: 'visibilityManageOpeningClosingTimeAppointments',
      title: 'Gestione orari appuntamenti', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Attiva', icon: '', styleClass: '', value: 'visibilityManageOpeningClosingTimeAppointments_TRUE', },
        { title: 'Disattiva', icon: '', styleClass: '', value: 'visibilityManageOpeningClosingTimeAppointments_FALSE', }
      ]
    },
    {
      id: 'visibilityStoreManager',
      title: 'Visibilità storemanager', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityStoreManager_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityStoreManager_FALSE', }
      ]
    },
    {
      id: 'visibilityStoreManagerEmail',
      title: 'Visibilità Email storemanager', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityStoreManagerEmail_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityStoreManagerEmail_FALSE', }
      ]
    },
    {
      id: 'visibilityStoreManagerPhoto',
      title: 'Visibilità Immagine storemanager', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityStoreManagerPhoto_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityStoreManagerPhoto_FALSE', }
      ]
    },
    {
      id: 'visibilityStoreManagerTelephone',
      title: 'Visibilità Telefono storemanager', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityStoreManagerTelephone_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityStoreManagerTelephone_FALSE', }
      ]
    },
    {
      id: 'visibilityDigitalCoupon',
      title: 'Visibilità Digital Coupon', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'visibilityDigitalCoupon_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'visibilityDigitalCoupon_FALSE', }
      ]
    },
  ];





  /**
   * Configura i button del menù modifiche di massa
   */
  public massModifyItems: MassModifyItem[] = [
    {
      title: 'Promozione ed Eventi',
      value: '',
      styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'promozioneEventi_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'promozioneEventi_REMOVE', }
      ]
    },
    {
      title: 'Prodotti e Servizi',
      value: '',
      styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'productAndServices_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'productAndServices_REMOVE', }
      ]
    },
    {
      title: 'Supervisori', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'supervisori_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'supervisori_REMOVE', }
      ]
    },
    {
      title: 'Head image', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'headImageId_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'headImageId_REMOVE', }
      ]
    },
    {
      title: 'Galleria', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'galleryIds_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'galleryIds_REMOVE', }
      ]
    },
    {
      title: 'Galleria interna', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'internalGalleryIds_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'internalGalleryIds_REMOVE', }
      ]
    },
    {
      title: 'Accessori', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'accessoryIds_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'accessoryIds_REMOVE', }
      ]
    },
    {
      title: 'Telefono per WhatsApp', value: '', styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Aggiungi', icon: '', styleClass: '', value: 'whatsapp_ADD', },
        { title: 'Rimuovi', icon: '', styleClass: '', value: 'whatsapp_REMOVE', }
      ]
    },
    { styleClass: 'dropdown-divider' },
    {
      title: 'Pubblica',
      value: '',
      styleClass: 'dropdown-submenu',
      choice: [
        { title: 'Si', icon: '', styleClass: '', value: 'PUBLIC_TRUE', },
        { title: 'No', icon: '', styleClass: '', value: 'PUBLIC_FALSE', }
      ]
    },
  ];



  choiceButtonMassModifyResponse(value) {
    let isOk = this.onClickControllItemMassModify();
    if (isOk === TRUE) {
      let flagName = "";
      switch (value) {
        case 'PUBLIC_TRUE': this.onClickButtonItemMassModify_public(true); break;
        case 'PUBLIC_FALSE': this.onClickButtonItemMassModify_public(false); break;
        case 'promozioneEventi_ADD': this.onClickButtonItemMassModify_promozioneEventi('ADD'); break;
        case 'promozioneEventi_REMOVE': this.onClickButtonItemMassModify_promozioneEventi('REMOVE'); break;
        case 'productAndServices_ADD': this.onClickButtonItemMassModify_productAndServices('ADD'); break;
        case 'productAndServices_REMOVE': this.onClickButtonItemMassModify_productAndServices('REMOVE'); break;
        case 'supervisori_ADD': this.onClickButtonItemMassModify_supervisori('ADD'); break;
        case 'supervisori_REMOVE': this.onClickButtonItemMassModify_supervisori('REMOVE'); break;
        case 'headImageId_ADD': this.onClickButtonItemMassModify_addheadImageId(); break;
        case 'headImageId_REMOVE': this.onClickButtonItemMassModify_removeheadImageId(); break;
        case 'galleryIds_ADD': this.onClickButtonItemMassModify_galleryIds('ADD'); break;
        case 'galleryIds_REMOVE': this.onClickButtonItemMassModify_galleryIds('REMOVE'); break;
        case 'internalGalleryIds_ADD': this.onClickButtonItemMassModify_internalGalleryIds('ADD'); break;
        case 'internalGalleryIds_REMOVE': this.onClickButtonItemMassModify_internalGalleryIds('REMOVE'); break;
        case 'accessoryIds_ADD': this.onClickButtonItemMassModify_accessoryIds('ADD'); break;
        case 'accessoryIds_REMOVE': this.onClickButtonItemMassModify_accessoryIds('REMOVE'); break;
        case 'whatsapp_ADD': this.onClickButtonItemMassModify_whatsapp('ADD'); break;
        case 'whatsapp_REMOVE': this.onClickButtonItemMassModify_whatsapp('REMOVE'); break;


        //Flags
        case 'visibilityClickAndCollectSim_TRUE':
        case 'visibilityClickAndCollectSmartphone_TRUE':
        case 'visibilityEmail_TRUE':
        case 'visibilityEvent_TRUE':
        case 'visibilityFacebook_TRUE':
        case 'visibilityFullStoreDescription_TRUE':
        case 'visibilityGallery_TRUE':
        case 'visibilityGooglePlace_TRUE':
        case 'visibilityInternalGallery_TRUE':
        case 'visibilityManageOpeningClosingTime_TRUE':
        case 'visibilityManageOpeningClosingTimeAppointments_TRUE':
        case 'visibilityOpeningClosingTime_TRUE':
        case 'visibilityPromotion_TRUE':
        case 'visibilityScheduleAppointments_TRUE':
        case 'visibilityServices_TRUE':
        case 'visibilityStoreManager_TRUE':
        case 'visibilityStoreManagerEmail_TRUE':
        case 'visibilityStoreManagerPhoto_TRUE':
        case 'visibilityStoreManagerTelephone_TRUE':
        case 'visibilityTelephone_TRUE':
        case 'visibilityVideocallme_TRUE':
        case 'visibilityDigitalCoupon_TRUE':
          flagName = value.split("_")[0];
          this.onClickButtonItemMassModify_flags(flagName, true);
          break;

        case 'visibilityClickAndCollectSim_FALSE':
        case 'visibilityClickAndCollectSmartphone_FALSE':
        case 'visibilityEmail_FALSE':
        case 'visibilityEvent_FALSE':
        case 'visibilityFacebook_FALSE':
        case 'visibilityFullStoreDescription_FALSE':
        case 'visibilityGallery_FALSE':
        case 'visibilityGooglePlace_FALSE':
        case 'visibilityInternalGallery_FALSE':
        case 'visibilityManageOpeningClosingTime_FALSE':
        case 'visibilityManageOpeningClosingTimeAppointments_FALSE':
        case 'visibilityOpeningClosingTime_FALSE':
        case 'visibilityPromotion_FALSE':
        case 'visibilityScheduleAppointments_FALSE':
        case 'visibilityServices_FALSE':
        case 'visibilityStoreManager_FALSE':
        case 'visibilityStoreManagerEmail':
        case 'visibilityStoreManagerPhoto_FALSE':
        case 'visibilityStoreManagerTelephone_FALSE':
        case 'visibilityTelephone_FALSE':
        case 'visibilityVideocallme_FALSE':
        case 'visibilityDigitalCoupon_FALSE':
          flagName = value.split("_")[0];
          this.onClickButtonItemMassModify_flags(flagName, false);
          break;
      }
    }
  }

  getLabelFlag(value) {
    let res = "";
    for (let obj of this.massModifyItemsFlags) {
      if (obj.id === value) {
        res = obj.title;
      }
    }
    return res;
  }


  onClickButtonItemMassModify_public(value) {
    let list = this.getListChecked();
    let massModifyObj = [];
    for (let obj of list) {
      massModifyObj.push({
        id: obj.id,
        title: obj.title,
        loading: true,
        call: () => {
          return this.storeService.publish(obj.id, value)
        }
      });
    }
    if (list.length > 0) {
      this.openMultiLoadingView(massModifyObj);
    }
  }

  onClickButtonItemMassModify_flags(flag, value) {
    console.log(flag + " = " + value);
    let list = this.getListChecked();

    let request = {
      flags: {},
      storeIds: []
    }
    let storeIds = [];
    let massModifyObj = [];
    if (list.length > 0) {

      request.flags[flag] = value;
      for (let obj of list) {
        storeIds.push(obj.id);
      }
      request['storeIds'] = storeIds;

      let valueTitle = value ? 'Si' : 'No';
      let flagTitle = this.getLabelFlag(flag);
      let title = 'Caricamento massivo del flag ' + flagTitle + ' settato a ' + valueTitle;

      massModifyObj.push({
        id: 0,
        title: title,
        loading: true,
        call: () => {
          return this.storeService.updateMassiveFlag(request)
        }
      });
      let refreshTable = false;
      this.openMultiLoadingView(massModifyObj, refreshTable);
    }
  }




  //Promozione ed Eventi
  onClickButtonItemMassModify_promozioneEventi(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoicePromotioneventModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestPromotionEvent();
        request.promotionEventsIds = [];
        for (let obj of result) {
          request.promotionEventsIds.push(obj.id);
        }
        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          if (value === 'ADD') {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.addPromotionEvent(obj.id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.removePromotionEvent(obj.id, request)
              }
            });
          }
        }

        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //Prodotti e Servizi
  onClickButtonItemMassModify_productAndServices(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceProductserviceModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestProductServices();
        request.productServices = [];
        for (let obj of result) {
          request.productServices.push(obj.id);
        }
        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          if (value === 'ADD') {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.addProductServices(obj.id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.removeProductServices(obj.id, request)
              }
            });
          }
        }
        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //Supervisori
  onClickButtonItemMassModify_supervisori(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceSupervisoriModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let list = this.getListChecked();
        let request = new SupervisorGroupsRequestStores();
        request.storeIds = [];
        for (let obj of list) {
          request.storeIds.push(obj.id);
        }

        let massModifyObj = [];
        for (let i = 0; i < result.length; i++) {
          let title = result[i].name;
          if (value === 'ADD') {
            massModifyObj.push({
              id: result[i].id,
              title: title,
              loading: true,
              call: () => {
                return this.supervisorGroupsService.addStores(result[i].id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: list[i].id,
              title: title,
              loading: true,
              call: () => {
                return this.supervisorGroupsService.removeStores(result[i].id, request)
              }
            });
          }
        }
        if (result.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //Head image
  onClickButtonItemMassModify_addheadImageId() {
    //Apertura modale di modifica 
    const modalRef = this.modalService.open(LoadImageFromDamComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.multiple = false;
    modalRef.componentInstance.idImages = [];
    modalRef.result.then((result: any) => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestHeadImage();
        request.headImageId = result.images[0].id;
        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          massModifyObj.push({
            id: obj.id,
            title: obj.dealerDescription,
            loading: true,
            call: () => {
              return this.storeService.addHeadImage(obj.id, request)
            }
          });
        }
        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }

      }
    });
  }
  onClickButtonItemMassModify_removeheadImageId() {
    let list = this.getListChecked();
    let massModifyObj = [];
    for (let obj of list) {
      massModifyObj.push({
        id: obj.id,
        title: obj.dealerDescription,
        loading: true,
        call: () => {
          return this.storeService.removeHeadImage(obj.id)
        }
      });
    }
    if (list.length > 0) {
      this.openMultiLoadingView(massModifyObj);
    }
  }

  //Galleria
  onClickButtonItemMassModify_galleryIds(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceGalleriesModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestGalleries();
        request.galleryIds = [];
        for (let obj of result) {
          request.galleryIds.push(obj.id);
        }
        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          if (value === 'ADD') {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.addGalleries(obj.id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.removeGalleries(obj.id, request)
              }
            });
          }
        }
        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //Galleria interna
  onClickButtonItemMassModify_internalGalleryIds(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceInternalgalleriesModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestInternalGalleries();
        request.galleryIds = [];
        for (let obj of result) {
          request.galleryIds.push(obj.id);
        }

        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          if (value === 'ADD') {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.addInternalGalleries(obj.id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: obj.id,
              title: obj.dealerDescription,
              loading: true,
              call: () => {
                return this.storeService.removeInternalGalleries(obj.id, request)
              }
            });
          }
        }
        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //Accessori
  onClickButtonItemMassModify_accessoryIds(value) {
    //Apre modale selezione 
    const modalRef = this.modalService.open(ChoiceStoreaccessoryModalComponent, DIALOG_LARGE_CONFIG);
    modalRef.result.then(result => {
      if (result && result != "CLOSE") {
        let request = new StoreRequestAccessories();
        request.accessoryIds = [];
        for (let obj of result) {
          request.accessoryIds.push(obj.id);
        }
        let list = this.getListChecked();
        let massModifyObj = [];
        for (let obj of list) {
          let title = obj.dealerDescription;
          if (value === 'ADD') {
            massModifyObj.push({
              id: obj.id,
              title: title,
              loading: true,
              call: () => {
                return this.storeService.addAccessories(obj.id, request)
              }
            });
          } else {
            massModifyObj.push({
              id: obj.id,
              title: title,
              loading: true,
              call: () => {
                return this.storeService.removeAccessories(obj.id, request)
              }
            });
          }
        }
        if (list.length > 0) {
          this.openMultiLoadingView(massModifyObj);
        }
      }
    });
  }

  //whatsApp
  onClickButtonItemMassModify_whatsapp(value) {
    if (value === 'ADD') {
      //Apre modale selezione 
      const modalRef = this.modalService.open(UpdateWhatsappModalComponent, DIALOG_LARGE_CONFIG);
      modalRef.result.then(result => {
        if (result && result != "CLOSE") {
          this.addMassWhatsapp(result);
        }
      });
    } else {
      const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
      modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
      modalRef.componentInstance.actionTemplate.title = "Cencella whatsapp";
      modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare il campo Whatsapp";
      modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
      modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
      modalRef.result.then(result => {
        if (result) {
          if (result.confirm === TRUE) {
            //Cancella il numero
            this.removeMassWhatsapp();
          }
        }
      });
    }
  }

  addMassWhatsapp(phonenumber) {
    let request = new StoreRequestUpdateMassiveWhatsapp();
    request.whatsapp = phonenumber;
    let list = this.getListChecked();
    let massModifyObj = [];
    for (let obj of list) {
      massModifyObj.push({
        id: obj.id,
        title: obj.dealerDescription,
        loading: true,
        call: () => {
          return this.storeService.updateMassiveWhatsapp(obj.id, request)
        }
      });
    }
    if (list.length > 0) {
      this.openMultiLoadingView(massModifyObj);
    }
  }

  removeMassWhatsapp() {
    let request = new StoreRequestUpdateMassiveWhatsapp();
    request.whatsapp = null;
    let list = this.getListChecked();
    let massModifyObj = [];
    for (let obj of list) {
      massModifyObj.push({
        id: obj.id,
        title: obj.dealerDescription,
        loading: true,
        call: () => {
          return this.storeService.updateMassiveWhatsapp(obj.id, request)
        }
      });
    }
    if (list.length > 0) {
      this.openMultiLoadingView(massModifyObj);
    }
  }

}
